// @flow

import React from 'react';
import { QueryRenderer, graphql } from 'react-relay';
import get from 'lodash.get';

import TagProjectModal from './TagProjectModal';

import type { Environment } from 'react-relay';

type RendererProps = {
    environment: Environment,
    itemId: string,
    userId: string,

    // needed for children only
    isOpen?: boolean,
    onClose: () => void,
    onDone: Function,
};

const TagProjectModalRenderer = (rendererProps: RendererProps) => {
    const { environment, itemId, userId } = rendererProps;

    const variables = {
        itemId,
        userId,
        userIds: [userId],
    };

    return (
        <QueryRenderer
            environment={environment}
            query={graphql`
                query TagProjectModalRendererQuery(
                    $itemId: String!
                    $userId: String!
                    $userIds: [String]
                ) {
                    viewer {
                        item(itemId: $itemId, pageType: PROJECT_FORMS) {
                            ...TagProjectModal_item
                        }
                        ...TagProjectModal_viewer
                    }
                }
            `}
            variables={variables}
            render={({ error, props: relayProps }) => {
                // eslint-disable-line react/prop-types, react/display-name
                if (!error) {
                    return (
                        <TagProjectModal
                            {...rendererProps}
                            item={get(relayProps, 'viewer.item') || null}
                            viewer={get(relayProps, 'viewer') || null}
                        />
                    );
                }

                console.warn('Failed to open TagProjectModal. Error:', error);
                return null;
            }}
        />
    );
};

export default TagProjectModalRenderer;
